import React from "react";
import { Radio } from "@material-ui/core";
import clsx from "clsx";
import moment from "moment-timezone";
import useCurrentFacilityTimezone from "../../../hooks/useCurrentFacilityTimezone";
import Currency from "../../Currency";
import { useStyles } from "./RefundTransactionList.styles";

const RefundTransactionList = ({
  results = [],
  selectedTransactionId,
  onSelectTransaction,
}) => {
  const classes = useStyles();
  const { timeZone } = useCurrentFacilityTimezone();

  const handleRadioChange = (transaction) => {
    if (onSelectTransaction) {
      onSelectTransaction(transaction);
    }
  };

  if (!results || results.length === 0) {
    return (
      <div
        className={clsx([
          "animate__animated",
          "animate__flipInX",
          "results",
          "not-found",
          classes.noResults,
        ])}
      >
        <span className={clsx(["no-results-text"])}>No results found</span>
      </div>
    );
  }

  return (
    <div className={clsx(classes.tableWrapper)}>
      <table
        className={clsx(classes.resultTable)}
        data-testid="refund-transaction-list-table"
      >
        <thead className={clsx(classes.thHeader)}>
          <tr>
            <th></th>
            <th>Ticket Number</th>
            <th>Last 4 of CC</th>
            <th>Customer</th>
            <th>Date/Time</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>
          {results.map((transaction) => (
            <tr
              key={transaction.parkingTransactionID}
              className={clsx("clickable-row")}
              onClick={() => handleRadioChange(transaction)}
              data-selected={
                selectedTransactionId === transaction.parkingTransactionID
              }
              data-testid={`transaction-row-${transaction.parkingTransactionID}`}
            >
              <td data-column="" className={clsx(classes.radioCell)}>
                <Radio
                  checked={
                    selectedTransactionId === transaction.parkingTransactionID
                  }
                  onChange={() => handleRadioChange(transaction)}
                  value={transaction.parkingTransactionID}
                  color="primary"
                  className={clsx(classes.radio)}
                  data-testid={`radio-${transaction.parkingTransactionID}`}
                />
              </td>
              <td data-column="Ticket Number">{transaction.ticketNumber}</td>
              <td data-column="Last 4 of CC">{transaction.cardLast4}</td>
              <td data-column="Customer">
                {[transaction.customerFirstName, transaction.customerLastName]
                  .filter(Boolean)
                  .join(" ")}
              </td>
              <td data-column="Date/Time">
                {moment
                  .utc(transaction.paymentDateTime)
                  .tz(timeZone)
                  .format("MM/DD/YYYY h:mm A")}
              </td>
              <td data-column="Amount">
                <Currency value={transaction.amount ?? 0} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RefundTransactionList;
